import http from "../../http-common";

class AllCoursesService {
    getAllCourses() {
        return http.get(`/education/allcourses`);
    }
}

export default new AllCoursesService();
